import { toTitleCase } from "Utils";

const FormCheckOptionsWithYesNoLabels = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

const Operations = {
    EQUAL: "EQUAL",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN_OR_EQUAL: "GREATER_THAN_OR_EQUAL",
    LESS_THAN_OR_EQUAL: "LESS_THAN_OR_EQUAL",
};

const SortOrders = { asc: "asc", desc: "desc" };

const SortOrderReadable = {
    [SortOrders.asc]: "Ascending",
    [SortOrders.desc]: "Descending",
};

const OperationsAsOptions = Object.values(Operations).map((op) => ({
    label: toTitleCase(op),
    value: op,
}));

const SortData = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
];

const ChartColorCodes = {
    BLUE: "#4CADE9",
    DARK_BLUE: "#11355C",
    RED: "#DD3444",
    GREEN: "#61CE6C",
    OLIVE_GREEN: "#B5CC18",
    ORANGE: "#E57F3A",
    PINK: "#EA369C",
    PURPLE: "#7C25DA",
    YELLOW: "#FADF4B",
    GREY: "#393939",
    LIGHT_GREY: "#808080",
};

export {
    FormCheckOptionsWithYesNoLabels,
    Operations,
    OperationsAsOptions,
    SortOrders,
    SortOrderReadable,
    SortData,
    ChartColorCodes,
};


